import { SharedService } from './shared.service'
import {
  SearchStreetsRequest,
  SearchStreetsSuccess,
  SearchStreetsFailure,
  SearchCommunitiesRequest,
  SearchCommunitiesSuccess,
  SearchCommunitiesFailure,
  SearchContactTitlesRequest,
  SearchContactTitlesSuccess,
  SearchContactTitlesFailure,
  SearchContactTypesRequest,
  SearchContactTypesSuccess,
  SearchContactTypesFailure,
  SearchOrganizationRequest,
  SearchOrganizationSuccess,
  SearchOrganizationFailure,
  SearchIndustryRequest,
  SearchIndustrySuccess,
  SearchIndustryFailure,
  FetchImageTypesSuccess,
  FetchImageTypesRequest,
  FetchImageTypesFailure,
  SearchPaymentPurposesRequest,
  SearchPaymentPurposesSuccess,
  SearchPaymentPurposesFailure,
  SearchGisStreetsFailure,
  SearchGisStreetsSuccess,
  SearchGisStreetsRequest,
  SearchFinancialInstitutionRequest,
  SearchFinancialInstitutionSuccess,
  SearchFinancialInstitutionFailure,
  FetchSwitchableDataCyclesRequest,
  FetchSwitchableDataCyclesSuccess,
  FetchSwitchableDataCyclesFailure,
  FetchRoundFactorsRequest,
  FetchRoundFactorsSuccess,
  FetchRoundFactorsFailure,
  SearchWardsRequest,
  SearchWardsSuccess,
  SearchWardsFailure,
  DetectWardByCoordinateRequest,
  DetectWardByCoordinateSuccess,
  DetectWardByCoordinateFailure,
  FetchSearchTypesRequest,
  FetchSearchTypesSuccess,
  FetchSearchTypesFailure,
  FetchWardsRequest,
  FetchWardsSuccess,
  FetchWardsFailure,
  FetchDiscountGroupsRequest,
  FetchDiscountGroupsSuccess,
  FetchDiscountGroupsFailure,
  FetchAssessableTypesRequest,
  FetchAssessableTypesSuccess,
  FetchAssessableTypesFailure,
  FetchBusinessSubcategoryTypeRequest,
  FetchBusinessSubcategoryTypeSuccess,
  FetchBusinessSubcategoryTypeFailure,
  FetchBusinessSubcategoryCalculationTypeRequest,
  FetchBusinessSubcategoryCalculationTypeSuccess,
  FetchBusinessSubcategoryCalculationTypeFailure,
  ExportListDataRequest,
  ExportListDataSuccess,
  ExportListDataFailure,
  FetchPropertyStatusesSuccess,
  FetchPropertyStatusesFailure,
  FetchPropertyStatusesRequest,
  FetchActiveLayersRequest,
  FetchActiveLayersSuccess,
  FetchActiveLayersFailure,
  DetectLayerRequest,
  DetectLayerSuccess,
  DetectLayerFailure,
  DetectAllLayersRequest,
  DetectAllLayersSuccess,
  DetectAllLayersFailure,
  FetchOrganizationsRequest,
  FetchOrganizationsSuccess,
  FetchOrganizationsFailure,
  FetchBusinessCategoriesRequest,
  FetchBusinessCategoriesSuccess,
  FetchBusinessCategoriesFailure,
  FetchContactsSuccess,
  FetchContactsFailure,
  FetchContactsRequest,
  FetchContactTitlesRequest,
  FetchContactTitlesSuccess,
  FetchContactTitlesFailure,
  FetchFormsRequest,
  FetchFormsSuccess,
  FetchFormsFailure,
  FetchLayerFeaturesRequest,
  FetchLayerFeaturesSuccess,
  FetchLayerFeaturesFailure,
  FetchStaticTemplateRequest,
  FetchStaticTemplateSuccess,
  FetchStaticTemplateFailure,
  AcceptTermsOfServiceRequest,
  AcceptTermsOfServiceSuccess,
  AcceptTermsOfServiceFailure,
  FetchMobileTaskTypesRequest,
  FetchMobileTaskTypesSuccess,
  FetchMobileTaskTypesFailure,
  FetchTemplateTypesRequest,
  FetchTemplateTypesSuccess,
  FetchTemplateTypesFailure,
  FetchAreaRoundingRequest,
  FetchAreaRoundingSuccess,
  FetchAreaRoundingFailure,
  FetchAuditLogTypesSuccess,
  FetchAuditLogTypesRequest,
  FetchAuditLogTypesFailure,
  FetchPropertyTypesByCodeRequest,
  FetchPropertyTypesByCodeSuccess,
  FetchPropertyTypesByCodeFailure,
  FetchLicenseTypesRequest,
  FetchLicenseTypesSuccess,
  FetchLicenseTypesFailure,
  FetchPropertyTypesRequest,
  FetchPropertyTypesSuccess,
  FetchPropertyTypesFailure,
  FetchMobileUserModesFailure,
  FetchMobileUserModesSuccess,
  FetchMobileUserModesRequest,
  FetchPostprocessorSlotTypesRequest,
  FetchPostprocessorSlotTypesSuccess,
  FetchPostprocessorSlotTypesFailure,
  FetchDocumentTypesSuccess,
  FetchDocumentTypesFailure,
  FetchDocumentTypesRequest,
} from './shared.actions'
import { Injectable } from '@angular/core'
import { Observable, of, Subscription } from 'rxjs'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import * as SharedTypes from './shared.types'
import { ToastrService } from 'ngx-toastr'
import { map, tap, switchMap, catchError } from 'rxjs/operators'
import { Store, select } from '@ngrx/store'
import { TranslateService } from '@ngx-translate/core'
import { downloadBlob } from './shared.utils'
import { AuthService } from '@containers/auth/auth.service'

@Injectable()
export class SharedEffects {
  constructor(
    private actions: Actions,
    private toastrService: ToastrService,
    private sharedService: SharedService,
    private translateService: TranslateService,
    private authService: AuthService,
  ) {}

  ShowSnackbar$ = createEffect(
    () =>
      this.actions.pipe(
        ofType(SharedTypes.SHOW_SNACKBAR),
        tap((action: any) => {
          const { type, message } = action.payload
          this.toastrService[type](
            this.translateService.instant(message) || message,
          )
        }),
      ),
    { dispatch: false },
  )

  FetchImageTypes$ = createEffect(() =>
    this.actions.pipe(
      ofType(SharedTypes.FETCH_IMAGE_TYPES_REQUEST),
      switchMap((action: FetchImageTypesRequest) => {
        return this.sharedService.fetchImageTypes(action.model).pipe(
          map((result) => {
            return new FetchImageTypesSuccess(result.data)
          }),
          catchError((err, caught) => {
            return of(new FetchImageTypesFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  SearchStreets$ = createEffect(() =>
    this.actions.pipe(
      ofType(SharedTypes.SEARCH_STREETS_REQUEST),
      switchMap((action: SearchStreetsRequest) => {
        return this.sharedService.searchStreets(action.keyword).pipe(
          map((result) => {
            return new SearchStreetsSuccess(result.data.results)
          }),
          catchError((err, caught) => {
            return of(new SearchStreetsFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  SearchGisStreets$ = createEffect(() =>
    this.actions.pipe(
      ofType(SharedTypes.SEARCH_GIS_STREETS_REQUEST),
      switchMap((action: SearchGisStreetsRequest) => {
        return this.sharedService.searchGisStreets(action.keyword).pipe(
          map((result) => {
            return new SearchGisStreetsSuccess(result.data)
          }),
          catchError((err, caught) => {
            return of(new SearchGisStreetsFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  SearchCommunities$ = createEffect(() =>
    this.actions.pipe(
      ofType(SharedTypes.SEARCH_COMMUNITIES_REQUEST),
      switchMap((action: SearchCommunitiesRequest) => {
        return this.sharedService.searchCommunities(action.keyword).pipe(
          map((result) => {
            return new SearchCommunitiesSuccess(result.data.results)
          }),
          catchError((err, caught) => {
            return of(new SearchCommunitiesFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  SearchContactTitles$ = createEffect(() =>
    this.actions.pipe(
      ofType(SharedTypes.SEARCH_CONTACT_TITLES_REQUEST),
      switchMap((action: SearchContactTitlesRequest) => {
        return this.sharedService.searchContactTitles(action.keyword).pipe(
          map((result) => {
            return new SearchContactTitlesSuccess(result.data.results)
          }),
          catchError((err, caught) => {
            return of(new SearchContactTitlesFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  SearchPaymentPurposes$ = createEffect(() =>
    this.actions.pipe(
      ofType(SharedTypes.SEARCH_PAYMENT_PURPOSES_REQUEST),
      switchMap((action: SearchPaymentPurposesRequest) => {
        return this.sharedService.searchPaymentPurposes(action.keyword).pipe(
          map((result) => {
            return new SearchPaymentPurposesSuccess(result.data.results)
          }),
          catchError((err, caught) => {
            return of(new SearchPaymentPurposesFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  SearchOrganizations$ = createEffect(() =>
    this.actions.pipe(
      ofType(SharedTypes.SEARCH_ORGANIZATION_REQUEST),
      switchMap((action: SearchOrganizationRequest) => {
        return this.sharedService.searchOrganizations(action.keyword).pipe(
          map((result) => {
            return new SearchOrganizationSuccess(result.data.results)
          }),
          catchError((err, caught) => {
            return of(new SearchOrganizationFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  SearchIndustries$ = createEffect(() =>
    this.actions.pipe(
      ofType(SharedTypes.SEARCH_INDUSTRY_REQUEST),
      switchMap((action: SearchIndustryRequest) => {
        return this.sharedService.searchIndustries(action.keyword).pipe(
          map((result) => {
            return new SearchIndustrySuccess(result.data.results)
          }),
          catchError((err, caught) => {
            return of(new SearchIndustryFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  SearchContactTypes$ = createEffect(() =>
    this.actions.pipe(
      ofType(SharedTypes.SEARCH_CONTACT_TYPES_REQUEST),
      switchMap((action: SearchContactTypesRequest) => {
        return this.sharedService.searchContactTypes(action.keyword).pipe(
          map((result) => {
            return new SearchContactTypesSuccess(result.data.results)
          }),
          catchError((err, caught) => {
            return of(new SearchContactTypesFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  FetchOrganizations$ = createEffect(() =>
    this.actions.pipe(
      ofType(SharedTypes.FETCH_ORGANIZATIONS_REQUEST),
      switchMap((action: FetchOrganizationsRequest) => {
        return this.sharedService.fetchOrganizations(action.payload).pipe(
          map((result) => {
            return new FetchOrganizationsSuccess(result.data.results)
          }),
          catchError((err, caught) => {
            return of(new FetchOrganizationsFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  FetchBusinessCategories$ = createEffect(() =>
    this.actions.pipe(
      ofType(SharedTypes.FETCH_BUSINESS_CATEGORIES_REQUEST),
      switchMap((action: FetchBusinessCategoriesRequest) => {
        return this.sharedService.fetchBusinessCategories(action.payload).pipe(
          map((result) => {
            return new FetchBusinessCategoriesSuccess(result.data.results)
          }),
          catchError((err, caught) => {
            return of(new FetchBusinessCategoriesFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  SearchFinancialInstitution$ = createEffect(() =>
    this.actions.pipe(
      ofType(SharedTypes.SEARCH_FINANCIAL_INSTITUTION_REQUEST),
      switchMap((action: SearchFinancialInstitutionRequest) => {
        return this.sharedService
          .searchFinancialInstitutions(action.keyword)
          .pipe(
            map((result) => {
              return new SearchFinancialInstitutionSuccess(result.data.results)
            }),
            catchError((err, caught) => {
              return of(new SearchFinancialInstitutionFailure({ error: err }))
            }),
          )
      }),
    ),
  )

  FetchSwitchableDataCycles$ = createEffect(() =>
    this.actions.pipe(
      ofType(SharedTypes.FETCH_SWITCHABLE_DATA_CYCLES_REQUEST),
      switchMap((action: FetchSwitchableDataCyclesRequest) => {
        return this.sharedService.fetchSwitchableDataCycles().pipe(
          map((result) => {
            return new FetchSwitchableDataCyclesSuccess(result.data.dataCycles)
          }),
          catchError((err, caught) => {
            return of(new FetchSwitchableDataCyclesFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  FetchRoundFactors$ = createEffect(() =>
    this.actions.pipe(
      ofType(SharedTypes.FETCH_ROUND_FACTORS_REQUEST),
      switchMap((action: FetchRoundFactorsRequest) => {
        return this.sharedService.fetchRoundFactors().pipe(
          map((result) => {
            return new FetchRoundFactorsSuccess(result.data)
          }),
          catchError((err, caught) => {
            return of(new FetchRoundFactorsFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  FetchAreaRounding$ = createEffect(() =>
    this.actions.pipe(
      ofType(SharedTypes.FETCH_AREA_ROUNDING_REQUEST),
      switchMap((action: FetchAreaRoundingRequest) => {
        return this.sharedService.fetchAreaRounding().pipe(
          map((result) => {
            return new FetchAreaRoundingSuccess(result.data)
          }),
          catchError((err, caught) => {
            return of(new FetchAreaRoundingFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  SearchWards$ = createEffect(() =>
    this.actions.pipe(
      ofType(SharedTypes.SEARCH_WARDS_REQUEST),
      switchMap((action: SearchWardsRequest) => {
        return this.sharedService.searchWards(action.keyword).pipe(
          map((result) => {
            return new SearchWardsSuccess(result.data.results)
          }),
          catchError((err, caught) => {
            return of(new SearchWardsFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  DetectWardByCoordinate$ = createEffect(() =>
    this.actions.pipe(
      ofType(SharedTypes.DETECT_WARD_BY_COORDINATE_REQUEST),
      switchMap((action: DetectWardByCoordinateRequest) => {
        return this.sharedService
          .detectWardByCoordinate(action.coordinate)
          .pipe(
            map((result) => {
              return new DetectWardByCoordinateSuccess(result.data)
            }),
            catchError((err, caught) => {
              return of(new DetectWardByCoordinateFailure({ error: err }))
            }),
          )
      }),
    ),
  )

  FetchWards$ = createEffect(() =>
    this.actions.pipe(
      ofType(SharedTypes.FETCH_WARDS_REQUEST),
      switchMap((action: FetchWardsRequest) => {
        return this.sharedService.fetchWards().pipe(
          map((result) => {
            return new FetchWardsSuccess(result.data.wards)
          }),
          catchError((err, caught) => {
            return of(new FetchWardsFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  FetchDiscountGroups$ = createEffect(() =>
    this.actions.pipe(
      ofType(SharedTypes.FETCH_DISCOUNT_GROUPS_REQUEST),
      switchMap((action: FetchDiscountGroupsRequest) => {
        return this.sharedService.fetchDiscountGroups().pipe(
          map((result) => {
            return new FetchDiscountGroupsSuccess(result.data.results)
          }),
          catchError((err, caught) => {
            return of(new FetchDiscountGroupsFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  FetchAssessableTypes$ = createEffect(() =>
    this.actions.pipe(
      ofType(SharedTypes.FETCH_ASSESSABLE_TYPES_REQUEST),
      switchMap((action: FetchAssessableTypesRequest) => {
        return this.sharedService.fetchAssessableTypes().pipe(
          map((result) => {
            return new FetchAssessableTypesSuccess(result.data)
          }),
          catchError((err, caught) => {
            return of(new FetchAssessableTypesFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  FetchPropertyStatuses$ = createEffect(() =>
    this.actions.pipe(
      ofType(SharedTypes.FETCH_PROPERTY_STATUSES_REQUEST),
      switchMap((action: FetchPropertyStatusesRequest) => {
        return this.sharedService.fetchPropertyStatuses().pipe(
          map((result) => {
            return new FetchPropertyStatusesSuccess(result.data)
          }),
          catchError((err, caught) => {
            return of(new FetchPropertyStatusesFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  FetchBusinessSubcategoryTypes$ = createEffect(() =>
    this.actions.pipe(
      ofType(SharedTypes.FETCH_BUSINESS_SUBCATEGORY_TYPE_REQUEST),
      switchMap((action: FetchBusinessSubcategoryTypeRequest) => {
        return this.sharedService.fetchBusinessSubcategoryTypes().pipe(
          map((result) => {
            return new FetchBusinessSubcategoryTypeSuccess(result.data)
          }),
          catchError((err, caught) => {
            return of(new FetchBusinessSubcategoryTypeFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  FetchContacts$ = createEffect(() =>
    this.actions.pipe(
      ofType(SharedTypes.FETCH_CONTACTS_REQUEST),
      switchMap((action: FetchContactsRequest) => {
        return this.sharedService.fetchContacts(action.payload).pipe(
          map((result) => {
            return new FetchContactsSuccess(result.data.results)
          }),
          catchError((err, caught) => {
            return of(new FetchContactsFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  FetchBusinessSubcategoryCalculationTypes$ = createEffect(() =>
    this.actions.pipe(
      ofType(SharedTypes.FETCH_BUSINESS_SUBCATEGORY_CALCULATION_TYPE_REQUEST),
      switchMap((action: FetchBusinessSubcategoryCalculationTypeRequest) => {
        return this.sharedService
          .fetchBusinessSubcategoryCalculationTypes()
          .pipe(
            map((result) => {
              return new FetchBusinessSubcategoryCalculationTypeSuccess(
                result.data,
              )
            }),
            catchError((err, caught) => {
              return of(
                new FetchBusinessSubcategoryCalculationTypeFailure({
                  error: err,
                }),
              )
            }),
          )
      }),
    ),
  )

  DownloadListData$ = createEffect(() =>
    this.actions.pipe(
      ofType(SharedTypes.EXPORT_LIST_DATA_REQUEST),
      switchMap((action: ExportListDataRequest) => {
        return this.sharedService.exportListData(action.payload).pipe(
          map((result) => {
            return new ExportListDataSuccess(result, action.payload)
          }),
          catchError((err, caught) => {
            return of(new ExportListDataFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  SaveListData$ = createEffect(
    () =>
      this.actions.pipe(
        ofType<ExportListDataSuccess>(SharedTypes.EXPORT_LIST_DATA_SUCCESS),
        tap((action) => downloadBlob(action.blob)),
      ),
    { dispatch: false },
  )

  FetchActiveLayers$ = createEffect(() =>
    this.actions.pipe(
      ofType(SharedTypes.FETCH_ACTIVE_LAYERS_REQUEST),
      switchMap((action: FetchActiveLayersRequest) => {
        return this.sharedService.fetchActiveLayers(action.payload).pipe(
          map((result) => {
            return new FetchActiveLayersSuccess(
              action.payload ? result.data.results : result.data,
            )
          }),
          catchError((err, caught) => {
            return of(
              new FetchActiveLayersFailure({
                error: err,
              }),
            )
          }),
        )
      }),
    ),
  )

  DetectLayer$ = createEffect(() =>
    this.actions.pipe(
      ofType(SharedTypes.DETECT_LAYER_REQUEST),
      switchMap((action: DetectLayerRequest) => {
        return this.sharedService.detectLayer(action.payload).pipe(
          map((result) => {
            return new DetectLayerSuccess(result.data)
          }),
          catchError((err, caught) => {
            return of(
              new DetectLayerFailure({
                error: err,
              }),
            )
          }),
        )
      }),
    ),
  )

  DetectAllLayers$ = createEffect(() =>
    this.actions.pipe(
      ofType(SharedTypes.DETECT_ALL_LAYERS_REQUEST),
      switchMap((action: DetectAllLayersRequest) => {
        return this.sharedService.detectAllLayers(action.payload).pipe(
          map((result) => {
            return new DetectAllLayersSuccess(result.data)
          }),
          catchError((err, caught) => {
            return of(
              new DetectAllLayersFailure({
                error: err,
              }),
            )
          }),
        )
      }),
    ),
  )

  FetchContactTitles$ = createEffect(() =>
    this.actions.pipe(
      ofType(SharedTypes.FETCH_CONTACT_TITLES_REQUEST),
      switchMap((action: FetchContactTitlesRequest) => {
        return this.sharedService.fetchContactTitles(action.payload).pipe(
          map((result) => {
            return new FetchContactTitlesSuccess(result.data.results)
          }),
          catchError((err, caught) => {
            return of(new FetchContactTitlesFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  FetchForms$ = createEffect(() =>
    this.actions.pipe(
      ofType(SharedTypes.FETCH_FORMS_REQUEST),
      switchMap((action: FetchFormsRequest) => {
        return this.sharedService.fetchForms().pipe(
          map((result) => {
            return new FetchFormsSuccess(result.data.results)
          }),
          catchError((err, caught) => {
            return of(new FetchFormsFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  FetchLayerFeatures$ = createEffect(() =>
    this.actions.pipe(
      ofType(SharedTypes.FETCH_LAYER_FEATURES_REQUEST),
      switchMap((action: FetchLayerFeaturesRequest) => {
        return this.sharedService.fetchLayerFeatures(action.payload).pipe(
          map((result) => {
            return new FetchLayerFeaturesSuccess(result.data.results)
          }),
          catchError((err, caught) => {
            return of(
              new FetchLayerFeaturesFailure({
                error: err,
              }),
            )
          }),
        )
      }),
    ),
  )

  FetchStaticTemplate$ = createEffect(() =>
    this.actions.pipe(
      ofType(SharedTypes.FETCH_STATIC_TEMPLATE_REQUEST),
      switchMap((action: FetchStaticTemplateRequest) => {
        return this.sharedService
          .fetchStaticTemplate(action.key, action.lang)
          .pipe(
            map((result) => {
              return new FetchStaticTemplateSuccess(result.data)
            }),
            catchError((err, caught) => {
              return of(
                new FetchStaticTemplateFailure({
                  error: err,
                }),
              )
            }),
          )
      }),
    ),
  )

  AcceptTermsOfService$ = createEffect(() =>
    this.actions.pipe(
      ofType(SharedTypes.ACCEPT_TERMS_OF_SERVICE_REQUEST),
      switchMap((action: AcceptTermsOfServiceRequest) => {
        return this.sharedService.acceptTermsOfService().pipe(
          map((result) => {
            return new AcceptTermsOfServiceSuccess(result.data)
          }),
          catchError((err, caught) => {
            return of(
              new AcceptTermsOfServiceFailure({
                error: err,
              }),
            )
          }),
        )
      }),
    ),
  )

  AcceptTermsOfServiceSuccess$ = createEffect(
    () =>
      this.actions.pipe(
        ofType(SharedTypes.ACCEPT_TERMS_OF_SERVICE_SUCCESS),
        tap(({ payload }) => {
          this.authService.setUser(payload)
        }),
      ),
    { dispatch: false },
  )

  FetchMobileTaskTypes$ = createEffect(() =>
    this.actions.pipe(
      ofType(SharedTypes.FETCH_MOBILE_TASK_TYPES_REQUEST),
      switchMap((action: FetchMobileTaskTypesRequest) => {
        return this.sharedService.fetchMobileTaskTypes().pipe(
          map((result) => {
            return new FetchMobileTaskTypesSuccess(result.data)
          }),
          catchError((err, caught) => {
            return of(
              new FetchMobileTaskTypesFailure({
                error: err,
              }),
            )
          }),
        )
      }),
    ),
  )

  FetchTemplateTypes$ = createEffect(() =>
    this.actions.pipe(
      ofType(SharedTypes.FETCH_TEMPLATE_TYPES_REQUEST),
      switchMap((action: FetchTemplateTypesRequest) => {
        return this.sharedService.fetchTemplateTypes().pipe(
          map((result) => {
            return new FetchTemplateTypesSuccess(result.data)
          }),
          catchError((err, caught) => {
            return of(
              new FetchTemplateTypesFailure({
                error: err,
              }),
            )
          }),
        )
      }),
    ),
  )

  FetchAuditLogTypes$ = createEffect(() =>
    this.actions.pipe(
      ofType(SharedTypes.FETCH_AUDIT_LOG_TYPES_REQUEST),
      switchMap((action: FetchAuditLogTypesRequest) => {
        return this.sharedService.fetchAuditLogTypes().pipe(
          map((result) => {
            return new FetchAuditLogTypesSuccess(result.data)
          }),
          catchError((err, caught) => {
            return of(
              new FetchAuditLogTypesFailure({
                error: err,
              }),
            )
          }),
        )
      }),
    ),
  )

  FetchPropertyTypesByCodeTypes$ = createEffect(() =>
    this.actions.pipe(
      ofType(SharedTypes.FETCH_PROPERTY_TYPES_BY_CODE_REQUEST),
      switchMap((action: FetchPropertyTypesByCodeRequest) => {
        return this.sharedService.fetchPropertyTypesByCode(action.code).pipe(
          map((result) => {
            return new FetchPropertyTypesByCodeSuccess(result.data)
          }),
          catchError((err, caught) => {
            return of(
              new FetchPropertyTypesByCodeFailure({
                error: err,
              }),
            )
          }),
        )
      }),
    ),
  )

  FetchLicenseTypes$ = createEffect(() =>
    this.actions.pipe(
      ofType(SharedTypes.FETCH_LICENSE_TYPES_REQUEST),
      switchMap((action: FetchLicenseTypesRequest) => {
        return this.sharedService.fetchLicenseTypes().pipe(
          map((result) => {
            return new FetchLicenseTypesSuccess(result.data.results)
          }),
          catchError((err, caught) => {
            return of(
              new FetchLicenseTypesFailure({
                error: err,
              }),
            )
          }),
        )
      }),
    ),
  )

  FetchPropertyTypes$ = createEffect(() =>
    this.actions.pipe(
      ofType(SharedTypes.FETCH_PROPERTY_TYPES_REQUEST),
      switchMap((action: FetchPropertyTypesRequest) => {
        return this.sharedService.fetchPropertyTypes(action.id).pipe(
          map((result) => {
            return new FetchPropertyTypesSuccess(result.data)
          }),
          catchError((err, caught) => {
            return of(
              new FetchPropertyTypesFailure({
                error: err,
              }),
            )
          }),
        )
      }),
    ),
  )

  FetchMobileUserModes$ = createEffect(() =>
    this.actions.pipe(
      ofType(SharedTypes.FETCH_MOBILE_USER_MODES_REQUEST),
      switchMap((action: FetchMobileUserModesRequest) => {
        return this.sharedService.fetchMobileUserModes().pipe(
          map((result) => {
            return new FetchMobileUserModesSuccess(result.data)
          }),
          catchError((err, caught) => {
            return of(
              new FetchMobileUserModesFailure({
                error: err,
              }),
            )
          }),
        )
      }),
    ),
  )

  FetchPostprocessorSlotTypes$ = createEffect(() =>
    this.actions.pipe(
      ofType(SharedTypes.FETCH_POSTPROCESSOR_SLOT_TYPES_REQUEST),
      switchMap((action: FetchPostprocessorSlotTypesRequest) => {
        return this.sharedService.fetchPostprocessorSlotTypes().pipe(
          map((result) => {
            return new FetchPostprocessorSlotTypesSuccess(result.data)
          }),
          catchError((err, caught) => {
            return of(
              new FetchPostprocessorSlotTypesFailure({
                error: err,
              }),
            )
          }),
        )
      }),
    ),
  )

  FetchDocumentTypes$ = createEffect(() =>
    this.actions.pipe(
      ofType(SharedTypes.FETCH_DOCUMENT_TYPES_REQUEST),
      switchMap((action: FetchDocumentTypesRequest) => {
        return this.sharedService.fetchDocumentTypes().pipe(
          map((result) => {
            return new FetchDocumentTypesSuccess(result.data.results)
          }),
          catchError((err, caught) => {
            return of(
              new FetchDocumentTypesFailure({
                error: err,
              }),
            )
          }),
        )
      }),
    ),
  )
}
